// Required for stuff to be available outside the bundle
window.$ = window.jQuery = require("jquery");
window.wNumb = require('wnumb');
